import type { JobFunction } from "../../job";

export default class JobFailedError extends Error {
	failedAt: Date;
	failedIn: JobFunction;
	failedBecauseOf: Error;

	constructor(failedAt: Date, failedIn: JobFunction, failedBecauseOf: Error) {
		super(`Job failed at ${failedIn}`);
		this.failedAt = failedAt;
		this.failedIn = failedIn;
		this.failedBecauseOf = failedBecauseOf;
	}
}
